
import disableScrolling from '../mixins/disableScrolling';

export default {
  mixins: [disableScrolling()],
  props: {
    title: {
      type: String,
      default: undefined
    },

    compact: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close () {
      this.$emit('close');
    }
  }
};
